import React from 'react';
import { hideLanguageSelector } from '../utility/languageSelector';

export default function withLanguageSelectorHidden(WrappedComponent) {
  return class extends React.Component {
    componentDidMount() {
      hideLanguageSelector();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
